module.exports = __webpack_public_path__ + "static/media/upload.7f923874.svg";